import { render, staticRenderFns } from "./SimpleCourse.vue?vue&type=template&id=ef24f3ca&scoped=true&"
import script from "./SimpleCourse.vue?vue&type=script&lang=js&"
export * from "./SimpleCourse.vue?vue&type=script&lang=js&"
import style0 from "./SimpleCourse.vue?vue&type=style&index=0&id=ef24f3ca&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef24f3ca",
  null
  
)

export default component.exports